import { Component } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import { FeatureRefs } from '../cssFeatures.types'
import { masterPageFontFamilies } from './componentsFontFamilies/masterPageFontFamilies'
import { richTextFontFamilies } from './componentsFontFamilies/richTextFontFamilies'
import { styleFontFamilies } from './componentsFontFamilies/styleFontFamilies'
import { textMaskFontFamilies } from './componentsFontFamilies/textMaskFontFamilies'
import { vectorImageFontFamilies } from './componentsFontFamilies/vectorImageFontFamilies'
import { svgImageFontFamilies } from './componentsFontFamilies/svgImageFontFamilies'
import { tpaFontFamilies } from './componentsFontFamilies/tpaFontFamilies'
import { madeforFontFamilies } from './componentsFontFamilies/madeforFontFamilies'
import { innerElementsStyleFontFamilies } from './componentsFontFamilies/innerElementsStyleFontFamilies'

const fontFamiliesCompNodes = {
	masterPageFontFamilies,
	textMaskFontFamilies,
	richTextFontFamilies,
	styleFontFamilies,
	vectorImageFontFamilies,
	tpaFontFamilies,
	madeforFontFamilies,
	svgImageFontFamilies,
	innerElementsStyleFontFamilies,
}

type FontFamiliesCompNodes = typeof fontFamiliesCompNodes
type FontFamiliesKeys = keyof FontFamiliesCompNodes

type FontFamiliesDependencies = {
	[key in FontFamiliesKeys]: ReturnType<FontFamiliesCompNodes[key]['compNode']['getDependencies']>
}

export const fontFamilies = createCssCompNode('fontFaces', 'fontFamilies', {
	getDependencies: (component: Component, refs: FeatureRefs<'fontFaces'>) => {
		const deps: any = {}
		for (const key in fontFamiliesCompNodes) {
			const { predicate, compNode } = fontFamiliesCompNodes[key as FontFamiliesKeys]
			if (predicate(component)) {
				deps[key as keyof FontFamiliesDependencies] = compNode.getDependencies(component, refs)
			}
		}
		return deps as FontFamiliesDependencies
	},
	toViewItem: (comp, deps) => {
		const componentFontFamilies: Set<string> = new Set()

		for (const key in deps) {
			const { compNode } = fontFamiliesCompNodes[key as FontFamiliesKeys]
			const fontFamiliesFromDep = compNode.toViewItem(comp, deps[key as keyof FontFamiliesDependencies] as any)
			fontFamiliesFromDep.forEach((fontFamily) => fontFamily && componentFontFamilies.add(fontFamily))
		}

		return componentFontFamilies
	},
})
